import { render, staticRenderFns } from "./TopoCustom.vue?vue&type=template&id=c5fe8806&scoped=true"
import script from "./TopoCustom.vue?vue&type=script&lang=js"
export * from "./TopoCustom.vue?vue&type=script&lang=js"
import style0 from "./TopoCustom.vue?vue&type=style&index=0&id=c5fe8806&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fe8806",
  null
  
)

export default component.exports